"use client";
import SubjectIcon from "@/app/components/logos/SubjectIcon";
import { Flex, Group, Stack, Title } from "@mantine/core";
import { Question } from "@tsTypes/question-schema";
import { TestStates } from "@tsTypes/test-schema";
import { default as NoCalcChip } from "./NoCalcChip";
import classes from "./QuestionHeader.module.css";
import QuestionDifficultyChip from "./QuestionDifficultyChip";
import QuestionFlagButton from "./QuestionFlagButton";

export default function QuestionHeader({
  subjectColorIndex,
  indx,
  questionDifficulty,
  requiresCalc,
  testId,
  isFlagged,
  testStatus,
  questionDocumentId,
}: {
  subjectColorIndex: string;
  indx: number | string;
  questionDifficulty?: Question["Difficulty"];
  requiresCalc: Question["RequiresCalc"];
  testId?: string;
  isFlagged?: boolean;
  testStatus?: TestStates;
  questionDocumentId?: string;
}) {
  return (
    <Flex align={"center"} className={classes.wrapper}>
      <Stack gap={4}>
        <Title order={5} className={classes.title}>
          Question {typeof indx === "number" ? indx + 1 : indx}
        </Title>
      </Stack>

      <Group ml="auto" gap="sm" align="center">
        <SubjectIcon subjectColorIndex={subjectColorIndex} />
        {!requiresCalc && <NoCalcChip />}
        <QuestionDifficultyChip difficulty={questionDifficulty ?? "Easy"} />
        {(testStatus === "taking" || testStatus === "paused") &&
          testId &&
          questionDocumentId && (
            <QuestionFlagButton
              testId={testId}
              questionDocumentId={questionDocumentId}
              isFlagged={isFlagged}
            />
          )}
      </Group>
    </Flex>
  );
}
